<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9570_37687)">
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="3.6"
        fill="url(#paint0_linear_9570_37687)"
      />
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="3.6"
        fill="url(#paint1_radial_9570_37687)"
      />
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="3.6"
        fill="url(#paint2_radial_9570_37687)"
      />
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="3.6"
        fill="url(#paint3_linear_9570_37687)"
      />
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="3.6"
        fill="url(#paint4_linear_9570_37687)"
      />
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="3.6"
        fill="url(#paint5_linear_9570_37687)"
      />
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="3.6"
        fill="url(#paint6_linear_9570_37687)"
      />
      <path
        d="M27.0005 14C26.6851 14 26.3746 13.8516 26.1802 13.5732C26.0494 13.3896 22.8511 9 15.9996 9C9.14801 9 5.94976 13.3896 5.81694 13.5762C5.4976 14.0259 4.87456 14.1328 4.42436 13.8159C3.97416 13.498 3.86479 12.8779 4.18022 12.4268C4.33549 12.2051 8.06987 7 15.9996 7C23.9292 7 27.6636 12.2051 27.8189 12.4268C28.1353 12.8789 28.0259 13.5024 27.5728 13.8193C27.399 13.9414 27.1988 14 27.0005 14Z"
        fill="#FCF2FF"
      />
      <path
        d="M23.1519 16.5298C23.3414 16.8335 23.6675 17 24.0005 17C24.1812 17 24.3648 16.9512 24.5298 16.8481C24.9976 16.5552 25.1402 15.9385 24.8472 15.4702C24.7339 15.2876 21.9849 11 15.9996 11C10.0142 11 7.26518 15.2876 7.1519 15.4702C6.85991 15.937 7.00151 16.5498 7.46733 16.8438C7.93022 17.1353 8.54838 16.9981 8.84526 16.5337C8.93706 16.3897 11.1548 13 15.9996 13C20.8443 13 23.0621 16.3897 23.1519 16.5298Z"
        fill="#FCF2FF"
      />
      <path
        d="M18.9992 22C18.9992 23.6569 17.6561 25 15.9992 25C14.3424 25 12.9992 23.6569 12.9992 22C12.9992 20.3432 14.3424 19 15.9992 19C17.6561 19 18.9992 20.3432 18.9992 22Z"
        fill="#FCF2FF"
      />
      <path
        d="M20.105 19.4473C20.2808 19.7979 20.6333 20.0005 21.0005 20C21.1509 20 21.3033 19.9663 21.4468 19.8945C21.941 19.6475 22.1411 19.0469 21.8941 18.5527C21.8218 18.4077 20.0708 15 15.9995 15C11.9283 15 10.1773 18.4077 10.105 18.5527C9.85893 19.0449 10.0581 19.6401 10.5484 19.8892C11.0376 20.1367 11.6382 19.9424 11.8911 19.4522C11.9429 19.3521 13.1861 17 15.9995 17C18.813 17 20.0562 19.3521 20.105 19.4473Z"
        fill="#FCF2FF"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_9570_37687"
        x1="16"
        y1="2"
        x2="16"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5BB3FD" />
        <stop
          offset="1"
          stop-color="#5194EC"
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_9570_37687"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.5 3.5) rotate(135) scale(3.53553 4.12942)"
      >
        <stop
          stop-color="#7AD3FE"
          stop-opacity="0.7"
        />
        <stop
          offset="1"
          stop-color="#7AD3FE"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9570_37687"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3 29) rotate(-40.6013) scale(4.60977 5.3841)"
      >
        <stop
          stop-color="#3F70D6"
          stop-opacity="0.7"
        />
        <stop
          offset="1"
          stop-color="#3F70D6"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint3_linear_9570_37687"
        x1="30"
        y1="16"
        x2="25.5"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#7AD3FE"
          stop-opacity="0"
        />
        <stop
          offset="0.479167"
          stop-color="#7AD3FE"
          stop-opacity="0.1"
        />
        <stop
          offset="1"
          stop-color="#7AD3FE"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_9570_37687"
        x1="16"
        y1="2"
        x2="16"
        y2="6"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#7AD3FE"
          stop-opacity="0"
        />
        <stop
          offset="0.479167"
          stop-color="#7AD3FE"
          stop-opacity="0.13"
        />
        <stop
          offset="1"
          stop-color="#7AD3FE"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_9570_37687"
        x1="16"
        y1="2"
        x2="16"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#3F70D6"
          stop-opacity="0.35"
        />
        <stop
          offset="0.058296"
          stop-color="#3F70D6"
          stop-opacity="0"
        />
        <stop
          offset="0.872197"
          stop-color="#3F70D6"
          stop-opacity="0"
        />
        <stop
          offset="0.939462"
          stop-color="#3F70D6"
          stop-opacity="0.438597"
        />
        <stop
          offset="1"
          stop-color="#3F70D6"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_9570_37687"
        x1="29.9012"
        y1="15.7489"
        x2="2.27791"
        y2="15.7489"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#3F70D6"
          stop-opacity="0.35"
        />
        <stop
          offset="0.058296"
          stop-color="#3F70D6"
          stop-opacity="0"
        />
        <stop
          offset="0.872197"
          stop-color="#3F70D6"
          stop-opacity="0"
        />
        <stop
          offset="0.939462"
          stop-color="#3F70D6"
          stop-opacity="0.438597"
        />
        <stop
          offset="1"
          stop-color="#3F70D6"
        />
      </linearGradient>
      <clipPath id="clip0_9570_37687">
        <rect
          width="32"
          height="32"
          fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
